import React from 'react'
import PropTypes from 'prop-types'
import { toUrlSafe } from 'utils/stringHelpers'
import ClassCard from 'components/dashboard/ClassCard'
import { TilesContainer } from 'components/dashboard/ActiveTabProgramCards/component.styles'
import {
  ClassesContainer,
  ButtonsContainer,
  Title,
  TitleContainer,
  StyledButton,
  StyledCreateClassIcon,
  StyledAwardIcon,
  HiddenCreateCourseContainer,
  TilesContainerWrapper,
} from './component.styles'
import {
  TITLE,
  CREATE_CLASS_BUTTON_TEXT,
  TRAINING_BUTTON_TEXT,
  TILES_CONTAINER_CLASS_NAME,
} from './constants'
import CreateCourse from 'experienceComponents/CreateCourse'
import { k8V2ContentfulMappings } from 'utils/productMaps'

const K8DigitalProgramCardV2 = ({
  classes,
  classMenuButtonRefs,
  currentProgramName,
  displayTitle,
  headerDataTestId,
  index,
  internalTitle,
  onClassBlur,
  onClassFocus,
  onComponentClick,
  programSubheader,
  setFocus,
  onTrainingClick,
  createCourseRef,
  handleCreateClassClick,
  contentfulCourses,
}) => {
  return (
    <TilesContainerWrapper>
      {/* FirstTimeClasses component - always render when showFirstTimeClasses is true */}

      <ClassesContainer>
        <TitleContainer>
          <Title>{TITLE}</Title>
        </TitleContainer>
        {classes &&
          classes.length > 0 && [
            <TilesContainer
              className={TILES_CONTAINER_CLASS_NAME}
              key={internalTitle}
            >
              {classes.map(
                (
                  {
                    completeLessons,
                    contentfulID,
                    instance,
                    scoID,
                    title,
                    totalLessons,
                  },
                  index,
                ) => {
                  const { displayTitle } =
                    k8V2ContentfulMappings?.find(course => {
                      return contentfulID === course.id
                    }) || {}
                  return (
                    <ClassCard
                      dataTestId={`class-card-${toUrlSafe(title)}`}
                      displayTitle={title}
                      gradeDisplayTitle={displayTitle}
                      instance={instance}
                      key={`class-card-${title}-${index}`}
                      onBlur={onClassBlur}
                      onClick={onComponentClick}
                      onFocus={() => onClassFocus(index)}
                      program={currentProgramName}
                      ref={classMenuButtonRefs.current[index]}
                      scoID={scoID}
                      setFocus={() =>
                        setFocus(classMenuButtonRefs.current[index])
                      }
                      totalAmount={totalLessons}
                      totalComplete={completeLessons}
                    />
                  )
                },
              )}
            </TilesContainer>,
          ]}
        <ButtonsContainer>
          <div style={{ position: 'relative' }}>
            <StyledButton onClick={handleCreateClassClick}>
              <StyledCreateClassIcon />
              {CREATE_CLASS_BUTTON_TEXT}
            </StyledButton>
            <HiddenCreateCourseContainer ref={createCourseRef}>
              <CreateCourse
                contentfulCourses={contentfulCourses}
                emptyClasses={true}
              />
            </HiddenCreateCourseContainer>
          </div>
          {onTrainingClick && (
            <StyledButton onClick={onTrainingClick}>
              <StyledAwardIcon />
              {TRAINING_BUTTON_TEXT}
            </StyledButton>
          )}
        </ButtonsContainer>
      </ClassesContainer>
    </TilesContainerWrapper>
  )
}

K8DigitalProgramCardV2.propTypes = {
  classMenuButtonRefs: PropTypes.object,
  classes: PropTypes.array,
  contentfulCourses: PropTypes.array,
  createCourseRef: PropTypes.object,
  currentProgramName: PropTypes.string,
  displayTitle: PropTypes.string,
  handleCreateClassClick: PropTypes.func,
  headerDataTestId: PropTypes.string,
  index: PropTypes.number,
  internalTitle: PropTypes.string,
  onClassBlur: PropTypes.func,
  onClassFocus: PropTypes.func,
  onComponentClick: PropTypes.func,
  onTrainingClick: PropTypes.func,
  programSubheader: PropTypes.string,
  setFocus: PropTypes.func,
  // FirstTimeClasses props
  showFirstTimeClasses: PropTypes.bool,
  staticLinksAvailable: PropTypes.array,
}

export default K8DigitalProgramCardV2
